export default __webpack_public_path__ + "static/media/hail.93cddf65.mp4";